import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  customerAdminFetchContactsSuccess,
  customerAdminShowContactMessage,
  submitNewCustomerAdminResponse,
  submitEditCustomerDetailsResponse,
  selectedCustomerDeleteResposne,
  toggleCustomerModal,
  customerFailResponse,
  setCustomerList,
  changeAdminLoader,
  adminBookFailResponse,
  updateCustomerList,
  fillCustomerProfileDetails,
  customerOnHideLoader
} from "../actions";
import {
  SUBMIT_EDIT_CUSTOMER_PROFILE,
  REQUEST_CUSTOMER_DATA,
  CUSTOMER_ON_HIDE_LOADER2
} from "../constants/ActionTypes";
import axios from "../services/customer";
import admin from "../services/admin";
import {formatPhone} from '../util/normalizePhone';

function* requestCustomerData(){
 try {

  const user = JSON.parse(localStorage.getItem('user-data'));
  // const customerDataResponse = yield axios.get(`/customers/${user.customer_details._id}`);
  console.log(user);
  
  } catch (error) {
    console.log(error);
    
  }
}

function* submitNewCustomer({ payload }) {
  try {
   
    
      const { formValues, imageFile } = payload;
      console.log("TCL: function*submitNewCustomer -> payload", payload)
      const { firstname, lastname, phonenumber, email, checkEmail, newPassword } = formValues;

      const password = newPassword.length === 0 ? null : newPassword;
      const userRequest = {
        firstname,
        lastname,
        phonenumber: '+'+phonenumber.replace(/[^\d]/g, ''),
        role: "5bce810face4410016946e83",
      };

      if (email !== checkEmail) {
        userRequest.email = email;
        userRequest.username = email;
      }

      if (password) {
        userRequest.password = password;
      }

      const userResponse = yield axios.put(`/users/${formValues._id}`, userRequest);
      console.log("USERRESPONSE",userResponse);
      
      const {
        address1,
        address2,
        city,
        stateId: state,
        zipcode,
        gender,
        country,
        _id,
      } = formValues;

      const { date_of_birth } = payload;
      const customerRequest = {
        date_of_birth,
        address1,
        address2,
        city,
        state,
        zipcode,
        gender,
        country,
        customer_details: userResponse.data._id,
      };

      const customerResponse = yield axios.put(`/customers/${userResponse.data.customer_details._id}`, customerRequest);
      const myCustomer = { ...userResponse.data };

      if (imageFile) {
        console.log('payload.imageid', payload.imageid)
        if(payload.imageid != "") {
        console.log('payload.imageid 1', payload.imageid)
        yield admin.delete(`/upload/files/${payload.imageid}`);
        }
        const file = new FormData();
        file.append("files", imageFile);
        file.append("refId", userResponse.data.customer_details._id);
        file.append("ref", "customers");
        file.append("field", "photo");

        const fileResponse = yield axios.post("/upload?files", file, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        myCustomer.photo = fileResponse.data === true ? imageFile : fileResponse.data[0];
      }
      myCustomer.phonenumber = formatPhone(myCustomer.phonenumber);
      const user = yield axios.get(`/users/${formValues._id}`);
      localStorage.setItem('user-data', JSON.stringify(user.data));
      yield put(fillCustomerProfileDetails());
      yield put(customerOnHideLoader());
  } catch (error) {
    yield put(customerFailResponse(error.response.data.message));
    yield put(adminBookFailResponse(error.response.data.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(SUBMIT_EDIT_CUSTOMER_PROFILE, submitNewCustomer),
    takeEvery(REQUEST_CUSTOMER_DATA,requestCustomerData)
  ]);
}



// WEBPACK FOOTER //
// ./sagas/CustomerProfile.js